import {withAppContext} from "../util/withAppContext";
import EnlilDetail from "./EnlilDetail";
import React from "react";
import {Button, Grid} from "@mui/material";
import css_button from "./Common/css/CCButton.module.scss";
import EventBus from "../util/EventBus";
import {prepareBuffer} from "../util/Buffer";
import MemoryContext from "../util/MemoryContext";


class EnlilDetailSearch extends EnlilDetail {

    evaluateSearchDisabledStatus() {
        for (let formElementIdentifier in this.state.controls) {
            if (formElementIdentifier.includes("_query")) continue;
            if (this.state.controls[formElementIdentifier].value === "") continue;
            else {
                return false;
            }
        }
        return true
    };

    enterpriseComponentNewQueryRecordStarted(ec) {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        this.setState({buffer: buffer[0]});
        this.prepareLocalState(buffer[0]);
    }

    prepareLocalState() {
        let buffer;
        buffer = this.applet.getEnterpriseComponent().getBuffer() ?? null;
        if (buffer !== null) {
            if (buffer.size > 0) buffer = buffer.get(this.applet.getEnterpriseComponent().getPagePointer());
            else if (buffer.size === 0) buffer = [];
        }

        if (!buffer) buffer = [];

        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        let row = buffer[0]

        let c = this.makeControls();
        let controls = c.controls;
        let groupCounter = c.groupCounter;

        if (this.state.action === "Query") {
            let keys = Object.keys(controls);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                if (controls[key]["csp"] === undefined) {
                    controls[key]["csp"] = {};
                }
                if (controls[key]["ip"] === undefined) {
                    controls[key]["ip"] = {};
                }

                let value = row.get(controls[key].enterpriseComponentAttribute) === null || row.get(controls[key].enterpriseComponentAttribute) === undefined ? "" : row.get(controls[key].enterpriseComponentAttribute);
                controls[key]["value"] = typeof value === "boolean" ? value : value.toString();
                //if (key.includes("_query")) {
                //    if (controls[key.substring(0,key.indexOf("_query"))]["type"] === "Select") {
                //        controls[key]["value"] = "Is in";
                //    } else {
                //        controls[key]["value"] = "Is equal to";
                //    }
                //}
                controls[key]["valid"] = true;
                controls[key]["touched"] = false;
                controls[key]["showSpinner"] = false;
                controls[key]["passwordVisible"] = false;

                if (controls[key].enterpriseComponentAttribute !== null) {
                    let attribute = this.applet.getEnterpriseComponent().getAttribute(controls[key].enterpriseComponentAttribute);
                    if (attribute !== undefined) {
                        if (attribute.getLength() !== null) {
                            controls[key]["ip"]["maxLength"] = attribute.getLength();
                        }
                    }
                }

                if (controls[key]["requiresConfirmation"]) {
                    controls[key]["hasBeenConfirmed"] = true;
                    controls[key]["confirmedValue"] = value.toString();
                }
            }
            this.setState({controls: controls, formIsValid: true, groupCounter: groupCounter, insertBackgroundOperation: false});
        }
    };

    triggerPostInputChangeHandler = () => {
        if (this.searchSpecification) this.applet.getEnterpriseComponent().setSearchSpecification(this.searchSpecification);
        this.applet.getEnterpriseComponent().setVisibilityMode(this.props.appContext.sessionContext.getActiveVisibility()?.Mode);
        this.applet.getEnterpriseComponent().setVisibilityValue(this.props.appContext.sessionContext.getActiveVisibility()?.Value);
        this.applet.getEnterpriseComponent().executeQuery(1, MemoryContext.components["SimpleSearchFormApplet-PageSize"]);
    }

    renderExtension() {
        let objectDetailContent = null;

        if (this.state.controls !== null) {
            let content = [];

            let groups = this.getGroups();
            for (let i = 0; i < groups.length; i++) {
                let group = groups[i];

                if (group["type"] === "standard") {
                    content.push(this.renderStandardGroup(group));
                } else if (group["type"] === "ondemand") {
                    content.push(this.renderOnDemandGroup(group));
                } else if (group["type"] === "checkbox") {
                    content.push(this.renderCheckboxGroup(group));
                }
            }

            objectDetailContent = (
                <Grid container spacing={5} rowSpacing={"0px"}>
                    {content}
                </Grid>
            );
        }

        return (
            <>
                <div style={{height: "20px"}}/>
                {objectDetailContent}
                <div style={{display: "flex", flexDirection: "row", marginTop: "20px", marginBottom: "10px"}}>
                    <Button disabled={this.evaluateSearchDisabledStatus()} className={css_button.blueStandardButton} variant="text" onClick={() => {
                        if (this.searchSpecification) this.applet.getEnterpriseComponent().setSearchSpecification(this.searchSpecification);
                        this.applet.getEnterpriseComponent().setVisibilityMode(this.props.appContext.sessionContext.getActiveVisibility()?.Mode);
                        this.applet.getEnterpriseComponent().setVisibilityValue(this.props.appContext.sessionContext.getActiveVisibility()?.Value);
                        this.applet.getEnterpriseComponent().executeQuery(1, MemoryContext.components["SimpleSearchFormApplet-PageSize"]);
                    }}>Search</Button>
                    <Button className={css_button.redStandardButton} style={{marginLeft: "20px"}} variant="text" onClick={() => {
                        EventBus.components.emit(this.applet.getEnterpriseComponent().serialNumber + "-form-applet-reset");
                    }}>Reset</Button>
                    <Button className={css_button.redStandardButton} style={{marginLeft: "20px"}} variant="text" onClick={() => {
                        EventBus.components.emit(this.applet.getEnterpriseComponent().serialNumber + "-form-applet-cancel");
                    }}>Cancel</Button>
                </div>
            </>
        );
    }
}

export default withAppContext(EnlilDetailSearch);